<div class="view-search">
    <div class="view-search__header">
        <!-- Search Header -->
        <div class="view-search__input-container">
            <!-- Search -->
            <input
                appAutoFocus
                appSelectOnFocus
                #searchInput 
                type="text"
                class="view-search__input"
                placeholder="Search Anatomy..."
                [value]="query"
                (keyup)="handleSearchKeyup($event,searchInput.value)">

            <button
                type="button"
                class="view-search__action"
                (click)="toggleDisplayMode()"
                [matTooltip]="(searchDisplayMode$ | async) === treeSearchDisplayMode.List ? 'Switch to Anatomy tree' : 'Switch to Anatomy list'">
                <app-icon [icon]="(searchDisplayMode$ | async) === treeSearchDisplayMode.List ? 'sitemap' : 'list'"></app-icon>
            </button>

            <div class="view-search__divider"></div>

            <!-- Exit -->
            <button
                type="button"
                class="view-search__action"
                (click)="handleExitClick()"
                matTooltip="Close search">
                <app-icon icon="times"></app-icon>
            </button>
        </div>
    </div>

    <div class="view-search__body">
        <app-tree-search
            [displayMode]="searchDisplayMode$ | async"
            [theme]="treeTheme.Themed"
            [query]="query"
            [viewGraph]="viewGraph$ | async">
        </app-tree-search>
    </div>
</div>
